import React from 'react';
import { ClockIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { CtaButton } from '../CtaButton';
import { PRECIO_TACHADO, PRECIO_VENTA } from '../../utils/constants';
export function Urgency() {
  return <section className="bg-[#FBE7DF] py-16 sm:py-20 px-5" data-id="element-293" data-mp="2bk0a24j7ko6f">
      <div className="max-w-3xl mx-auto text-center" data-id="element-294" data-mp="26kx3ugrhsbwv">
        <ClockIcon className="w-12 h-12 text-coral mx-auto animate-pulse" aria-hidden="true" data-id="element-295" data-mp="26m8acocbnxro" />
        <h2 className="mt-5 font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-296" data-mp="339uylyz8s9u1">
          El precio de lanzamiento termina cuando llegue a cero
        </h2>
        <p className="mt-4 text-lg text-tinta/75" data-id="element-297" data-mp="2uh1gzuwboyd0">
          Después vuelve a {PRECIO_TACHADO}. Hoy lo llevás a {PRECIO_VENTA}.
        </p>
        <Countdown className="mt-8" tone="light" data-id="element-298" data-mp="2phf3dkcl1g3o" />
        <CtaButton action="scroll" size="lg" className="mt-8" data-id="element-299" data-mp="3mzow8ton1j66">
          QUIERO EL PRECIO DE LANZAMIENTO
        </CtaButton>
      </div>
    </section>;
}